// extracted by mini-css-extract-plugin
module.exports = {"split":"Split--split--38arH"};